"use client";

import { cn } from "@kyan/ui";
import { useEffect } from "react";

import { AlertsHub } from "#/components/AlertsHub/AlertsHub";
import { MarketDropdown } from "#/components/MarketDropdown/MarketDropdown";
import { useShowTradePanel } from "#/store/app/tradePanel/showTradePanel";
import { useTradePanelTab } from "#/store/app/tradePanel/tradePanelTab";

import { PerpsLastTrades } from "./components/PerpsLastTrades/PerpsLastTrades";
import { PerpsMarketStats } from "./components/PerpsMarketStats/PerpsMarketStats";
import { PerpsOrderbook } from "./components/PerpsOrderbook/PerpsOrderbook";
import { PremiaChart } from "./components/PremiaChart/PremiaChart";

export default function Perps() {
  const { showTradePanel, setShowTradePanel } = useShowTradePanel();
  const { setTradePanelTab } = useTradePanelTab();

  useEffect(() => {
    setShowTradePanel(true);
    setTradePanelTab("perps");
  }, [setShowTradePanel, setTradePanelTab]);

  return (
    <main
      className={cn("flex flex-col gap-3 p-6 pt-4 transition-[margin]", {
        "mr-6": !showTradePanel,
      })}
    >
      <AlertsHub />
      <div className="mt-3 flex w-full items-center gap-6">
        <MarketDropdown type="perps" />
        <PerpsMarketStats />
      </div>
      <div className="flex h-[600px] gap-4">
        <PremiaChart className="w-full" />
        <div className="border-divider flex flex-col gap-4 rounded border bg-white p-3 dark:bg-transparent">
          <PerpsOrderbook layerSize={6} />
          <PerpsLastTrades />
        </div>
      </div>
    </main>
  );
}
